<template>
    <div class="view view-challenge-results">
        <HeaderChallengeResults
            :currentTab="currentTab" />

        <Preloader
            v-if="showPreloader"
            preloaderText="Yükleniyor..." />

        <template v-if="showChallengePracticeStats">
            <ChallengeResultsStatCorrectness
                :statCorrectness="statCorrectness" />
            <ChallengeResultsStats
                :statCorrect="statCorrect"
                :statIncorrect="statIncorrect"
                :statSkipped="statSkipped" />
        </template>


        <template v-if="showResultCompleted">
            <CardChallengeResultDeclarationCompleted
                :resultItem="resultItem" />
            <CardChallengeResultItemCompleted
                :resultItem="resultItem" />
            <CardChallengeResultStatWinLoss
                :resultItem="resultItem" />
        </template>

        <template v-if="showResultIncomplete">
            <CardChallengeResultDeclarationIncomplete
                :resultItem="resultItem" />
            <CardChallengeResultItemIncomplete
                :resultItem="resultItem" />
            <CardChallengeResultStatusTextIncomplete
                :resultItem="resultItem" />
        </template>
        


        <BtnChallengeResultsMainAction
            @click="nextTab" />
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    import HeaderChallengeResults           from '@/components/HeaderChallengeResults.vue';
    import Preloader                        from '@/components/Preloader.vue';

    import ChallengeResultsStatCorrectness  from '@/components/ChallengeResultsStatCorrectness.vue';
    import ChallengeResultsStats            from '@/components/ChallengeResultsStats.vue';

    import CardChallengeResultDeclarationCompleted  from '@/components/CardChallengeResultDeclarationCompleted';
    import CardChallengeResultItemCompleted         from '@/components/CardChallengeResultItemCompleted.vue';
    import CardChallengeResultStatWinLoss           from '@/components/CardChallengeResultStatWinLoss.vue';

    import CardChallengeResultDeclarationIncomplete from '@/components/CardChallengeResultDeclarationIncomplete.vue';
    import CardChallengeResultItemIncomplete from '@/components/CardChallengeResultItemIncomplete.vue';
    import CardChallengeResultStatusTextIncomplete from '@/components/CardChallengeResultStatusTextIncomplete.vue';

    import BtnChallengeResultsMainAction    from '@/components/BtnChallengeResultsMainAction.vue';

    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        components: {
            HeaderChallengeResults,
            Preloader,

            ChallengeResultsStatCorrectness,
            ChallengeResultsStats,
            BtnChallengeResultsMainAction,
            
            CardChallengeResultDeclarationCompleted,
            CardChallengeResultItemCompleted,
            CardChallengeResultStatWinLoss,

            CardChallengeResultDeclarationIncomplete,
            CardChallengeResultItemIncomplete,
            CardChallengeResultStatusTextIncomplete,
        },

        data(){
            return {
                showPreloader: true,
                currentTab: 'stats',
            };
        },

        computed: {
            showChallengePracticeStats(){
                if(this.showPreloader){
                    return false;
                }
                else if(this.currentTab === 'stats'){
                    return true;
                }
                return false;
            },

            showResultCompleted(){
                if(this.showPreloader){
                    return false;
                }
                else if(!this.resultItem){
                    return false;
                }
                else if(this.currentTab === 'challenge' && this.resultItem.status === 'COMPLETED'){
                    return true;
                }
                return false;
            },

            showResultIncomplete(){
                if(this.showPreloader){
                    return false;
                }
                else if(!this.resultItem){
                    return false;
                }
                else if(this.currentTab === 'challenge' && this.resultItem.status !== 'COMPLETED'){
                    return true;
                }
                return false;
            },

            resultItem(){
                let resultItem = this.$store.state.response.challengeResults.resultItem;
                return resultItem
                       ? resultItem
                       : undefined;
            },

            statCorrectness(){
                let curUserType = 'user' + this.$store.state.challengeSession.userType;
                return this.resultItem
                       ? this.resultItem.stats.correctness[curUserType]
                       : undefined;
            },

            statCorrect(){
                let curUserType = 'user' + this.$store.state.challengeSession.userType;
                return this.resultItem
                       ? this.resultItem.stats.correct[curUserType]
                       : undefined;
            },

            statIncorrect(){
                let curUserType = 'user' + this.$store.state.challengeSession.userType;
                return this.resultItem
                       ? this.resultItem.stats.incorrect[curUserType]
                       : undefined;
            },

            statSkipped(){
                let curUserType = 'user' + this.$store.state.challengeSession.userType;
                return this.resultItem
                       ? this.resultItem.stats.skipped[curUserType]
                       : undefined;
            }
        },

        methods: {
            nextTab(){
                // Activate challenge tab.
                if(this.currentTab === 'stats'){
                    this.currentTab = 'challenge';
                    return;
                }

                // Route to /challenge route.
                if(this.currentTab == 'challenge'){
                    this.$router.push('/challenge');
                }
            }
        },

        beforeMount(){
            document.querySelector('body').style = 'background-color: #FFFFFF';
        },

        mounted(){
            if(this.$store.state.envDev){
                this.showPreloader = true;
                fetch(this.$store.state.jsonServer.challengeResolveCompleted)
                .then(response => response.json())
                .then(resultItem => {
                    this.$store.commit('setChallengeResultsResultItem', resultItem);
                    this.showPreloader = false;
                });
            }
            else{
                this.showPreloader = true;
                fetch(this.$store.state.api.challengeResolve, {
                    method: 'POST',
                    credentials: 'include',
                })
                .then(async response => {
                    if(response.status !== 200){
                        throw await response.json();
                    }
                    return response.json();
                })
                .then(resultItem => {
                    this.$store.commit('setChallengeResultsResultItem', resultItem);
                    this.showPreloader = false;
                })
                .catch(err => {
                    if(err.code === 'CHALLENGE_RESOLVE_MODEL/RESOLVE::INV_USER_SESSION'){
                        this.$foneturkError({
                            text: this.$t(`error.api.challengeResolve.${err.code}`),
                            didClose: () => {
                                // this.$router.push('/login');
                            }
                        });
                        return false;
                    }
                    this.$foneturkError({
                        text: this.$t(`error.default`),
                        didClose: () => {
                            // this.$router.push('/');
                        }
                    });
                });
            }
        },

        unmounted(){
            // Revert body background style.
            document.querySelector('body').removeAttribute('style');
        }
    };
</script>

<style scoped src="@/css/views/view-challenge-results.css"></style>